import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        await axios.post('/api/accounts/verify-email/', {
          token: token
        });

        // Redirect immediately to sign-in with success state
        navigate('/signin', {
          state: {
            emailVerified: true,
            message: '✓ Email verified successfully! You can now sign in with your account.'
          }
        });
      } catch (err) {
        // Redirect to sign-in with error state
        let errorMessage = 'Email verification failed. ';
        if (err.response?.data?.token) {
          errorMessage += Array.isArray(err.response.data.token)
            ? err.response.data.token[0]
            : err.response.data.token;
        } else {
          errorMessage += 'Please try again or contact support.';
        }

        navigate('/signin', {
          state: {
            verificationError: true,
            message: errorMessage
          }
        });
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token, navigate]);

  return (
    <div className="verify-email-page">
      <div className="container" style={{ maxWidth: '500px', margin: '60px auto', padding: '40px', textAlign: 'center' }}>
        <div style={{
          fontSize: '48px',
          marginBottom: '20px',
          animation: 'spin 1s linear infinite'
        }}>
          ⏳
        </div>
        <h1 style={{ marginBottom: '20px' }}>Verifying Your Email...</h1>
        <p style={{ color: '#999' }}>
          Please wait while we verify your email address.
        </p>

        <style>{`
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default VerifyEmail;
